import Skeleton from '@mui/material/Skeleton';

export default function SkeletonIndications() {
    return (
        <div 
            className="flex flex-col w-full bg-white dark:bg-slate-900 rounded-[15px] shadow-md overflow-hidden border border-gray-100 dark:border-slate-800 animate-pulse mt-8"
            style={{ maxWidth: '350px', minHeight: '285px' }} // Mesma altura do card real
        >
            {/* 1. Área da Imagem (Simulando o container do gradiente) */}
            <div className="relative flex justify-center items-center p-6 h-[200px] bg-gray-100 dark:bg-slate-800">
                <Skeleton 
                    variant="rounded" 
                    width={90} 
                    height={130} 
                    sx={{ bgcolor: 'grey.400', borderRadius: '4px' }}
                />
                
                {/* Badge de Likes Fake no canto superior direito */}
                <div className="absolute top-2 right-2">
                    <Skeleton 
                        variant="rounded" 
                        width={45} 
                        height={24} 
                        sx={{ borderRadius: '20px', bgcolor: 'grey.500' }} 
                    />
                </div>
            </div>

            {/* 2. Rodapé de Informações (Padronizado) */}
            <div className="p-4 flex flex-col justify-center min-h-[85px] gap-2">
                {/* Skeleton do Título */}
                <Skeleton 
                    variant="text" 
                    width="85%" 
                    height={20} 
                    sx={{ bgcolor: 'grey.400', borderRadius: '4px' }} 
                />
                
                {/* Skeleton do Autor */}
                <Skeleton 
                    variant="text" 
                    width="50%" 
                    height={15} 
                    sx={{ bgcolor: 'grey.500', borderRadius: '4px' }} 
                />
            </div>
        </div>
    );
}